import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import { getImagesApi } from '../http/http';
import { FaBarsStaggered, FaCopyright, FaXmark } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Player/UI/Loader/Loader';
import Drawer from '../components/Drawer';
import AuthNavButtons from '../components/AuthNavButtons';
import { useAuth } from '../hooks/useAuth';
import { isAuthenticated, isSubscribedUser } from '../util/auth';

const HomePage = () => {

    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);
    const [drawer, setDrawer] = useState(false);
    const {
        loggedIn,
        subscribed,
        actionLoading,
        logout,
        handleUnsubscribe,
        goToSubscribe,
        goToLogin,
    } = useAuth();

    const goToCategory = (path) => {
        if (!isAuthenticated()) {
            navigate("/login", { state: { from: path } });
            return;
        }

        if (!isSubscribedUser()) {
            navigate("/subscribe", { state: { from: path } });
            return;
        }

        navigate(path);
    };

    const handleWatchNow = () => {
        goToCategory("/category/rhymes");
    };

    const fetchImages = async () => {
        try {
            setLoader(true);
            const response = await getImagesApi();
            console.log(response, 'resposne....');
            setData(response?.data);
            setLoader(false);

        } catch (error) {
            setLoader(false);

            console.log(error, 'error----');
        }
    }

    useEffect(() => {
        fetchImages();
    }, []);
    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                    <div className={classes.nav_items}>
                        <button type="button" className={`${classes.nav_item} ${classes.active}`}>
                            Home
                        </button>
                        <button type="button" className={classes.nav_item}
                            onClick={() => {
                                handleWatchNow();
                            }}
                        >
                            Categories
                        </button>
                        <AuthNavButtons
                            loggedIn={loggedIn}
                            subscribed={subscribed}
                            actionLoading={actionLoading}
                            onSubscribe={goToSubscribe}
                            onUnsubscribe={handleUnsubscribe}
                            onLogin={goToLogin}
                            onLogout={logout}
                            itemClassName={classes.nav_item}
                        />
                        <button type="button" className={classes.nav_item}>
                            Terms & Conditions
                        </button>
                        <button type="button" className={classes.nav_item_btn}
                            onClick={handleWatchNow}
                        >
                            Watch Now
                        </button>
                    </div>

                    <button type="button" className={classes.menu_bar}
                        onClick={() => {
                            setDrawer(!drawer)
                        }}
                    >
                        {drawer ?
                            <FaXmark
                                className={classes.menu_bar_icon}
                            />
                            :
                            <FaBarsStaggered className={classes.menu_bar_icon} />
                        }
                    </button>
                </nav>
            </header>

            {/* <section className={classes.section_landing_page}>
                <div className={classes.grid_container}>
                    <div className={classes.grid_section_one}>
                        <h1 className={classes.heading_one}>
                            <span className={classes.highlight_orange}>
                                DIVE
                            </span>{" "}
                            INTO THE
                        </h1>
                        <h1 className={classes.heading_two}>
                            GREATNESS OF </h1>
                        <h1 className={classes.heading_three}>
                            <span className={classes.highlight_green}>
                                LEARNING.
                            </span>
                        </h1>

                        <p className={classes.portal_description}>
                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                        </p>

                        <button type="button" className={classes.watch_now_btn}
                            onClick={() => {
                                navigate("/category/rhymes");
                            }}
                        >
                            Watch Now <FaChevronRight className={classes.arrow_right} />
                        </button>

                        <div className={classes.grid_sub_container}>
                            <div className={classes.kids_image_container}>
                                <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                            </div>
                            <div className={classes.kids_info}>
                                <p className={classes.kids_info_text_one}>Made For</p>
                                <p className={classes.kids_info_text_two}>- Kids</p>
                            </div>
                        </div>
                    </div>
                    <div className={classes.grid_section_two}>
                        <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />
                    </div>

                </div>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

            </section> */}

            <section className={classes.hero}>
                {/* Hero Content */}
                <div className={classes.heroContent}>
                    <div className={classes.left}>
                        <h4 className={classes.smallTitle}>Welcome to Kids Learning World</h4>

                        <h1 className={classes.mainTitle}>
                            Learn. Play. <br /> Grow Every Day!
                        </h1>

                        <p className={classes.description}>
                            Fun and interactive videos designed for children aged 2–10 to build
                            creativity, confidence, and essential learning skills in a joyful way.
                        </p>

                        <h3 className={classes.discount}>Explore 150+ Fun Learning Videos</h3>

                        <div className={classes.buttons}>
                            <button className={classes.searchBtn} onClick={handleWatchNow}>Watch Now</button>
                        </div>
                    </div>


                    <div className={classes.right}>
                        <img
                            src="/pngwing.com.png"
                            alt="kids-group"
                            className={classes.heroImage}
                        />
                    </div>
                    
                    <div className={classes.right2}>
                        <img
                            src="/pngwing.com (1).png"
                            alt="kids-group"
                            className={classes.heroImage}
                        />
                    </div>
                </div>
            </section>


            <section className={classes.section_categories_page}>
                <div className={classes.container}>
                    <h1 className={classes.section_categories_title}>Providing Good Qualities For Your Loving Kids</h1>
                    <div className={classes.section_categories_grid}>

                        <div className={classes.category_item}
                            onClick={() => goToCategory("/category/rhymes")}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/rhymes.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Ryhmes</h1>
                            <p className={classes.category_item_description}>
                                Kids rhymes are fun and educational songs that help young children learn language, rhythm, through catchy tunes and playful lyrics.
                            </p>

                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        goToCategory("/category/rhymes");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                        <div className={classes.category_item}
                            onClick={() => goToCategory("/category/learning")}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/book.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Learning</h1>
                            <p className={classes.category_item_description}>
                                Kids learning is all about helping children grow through fun, play, and simple lessons that build language, thinking, and social skills.
                            </p>
                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        goToCategory("/category/learning");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                        <div className={classes.category_item}
                            onClick={() => goToCategory("/category/stories")}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/fairytale.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Stories</h1>
                            <p className={classes.category_item_description}>
                                Kids stories spark imagination and teach values through fun characters and adventures, helping children learn and grow in a joyful way.
                            </p>
                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        goToCategory("/category/stories");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className={classes.section_product_page}>
                <div className={classes.container_product}>
                    <h1 className={classes.section_product_page_heading}>Special Care For Your Children</h1>

                    <div className={classes.section_product_page_grid}>
                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                                Content Type
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                                3 Categories
                            </p>
                        </div>

                        <div className={classes.divider}>
                        </div>

                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                                Browser Over
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                                150+ Videos
                            </p>
                        </div>
                    </div>

                    <h1 className={classes.section_product_page_heading2}>
                        Unlocking skills, One video at a time 🚀
                    </h1>

                    <p className={classes.section_product_page_paragraph}>
                        Unlock joyful learning with KidsLab: Videos that spark brilliance. Explore, Watch, Learn!
                    </p>
                </div>

                <img src="/assets/images/Book Illustration.png" alt="Book" className={classes.image_book_illustration} />
                <img src="/assets/images/World Illustration.png" alt="World" className={classes.image_world_illustration} />

                {loader ? <Loader on={loader} /> : (
                    <>
                        <div className={classes.section_carousel_marquee}>
                            <div className={classes.section_carousel_sub_container}>
                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}

                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </>
                )}


            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                BharatTech Solutions Pvt. Ltd.
                            </p>
                        </div>
                    </div>


                </div>
            </section>

            <Drawer
                setDrawer={setDrawer}
                drawer={drawer}
                loggedIn={loggedIn}
                subscribed={subscribed}
                actionLoading={actionLoading}
                onSubscribe={goToSubscribe}
                onUnsubscribe={handleUnsubscribe}
                onLogin={goToLogin}
                onLogout={logout}
                onWatchNow={handleWatchNow}
            />

        </main>
    )
}

export default HomePage;

const dummydata = [
    {
        image: ""
    }
]